import React from 'react';
import { AnchorProvider } from '@components/AnchorProvider/AnchorProvider';
import { LinkComponent } from '@components/LinkMenu/LinkComponent/LinkComponent';
import { MenuComponent } from '@components/LinkMenu/MenuComponent/MenuComponent';
import { LinkMenuProps } from '@components/LinkMenu/LinkMenuProps';

export const LinkMenu: React.FC<LinkMenuProps> = ({ label, icon, options, linkClassName, menuClassName, onClick }) => {
	return (
		<AnchorProvider>
			<LinkComponent label={label} icon={icon} className={linkClassName} onClick={onClick} />
			<MenuComponent options={options} className={menuClassName} />
		</AnchorProvider>
	);
};
